import { Component, Input, OnInit } from "@angular/core";
import { DataService_MultiStationViewVisitors } from "../shared/data.service";

@Component({
	selector: "caass-ms-visitor-history",
	templateUrl: "./ms-visitor-history.component.html",
	styleUrls: ["./ms-visitor-history.component.css"],
})
export class MsVisitorHistoryComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationViewVisitors) {}

	ngOnInit(): void {
		this.loadPasses();
	}

	ngOnChanges() {
		this.loadPasses();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedVisitor: any;

	lstVisitorPass: any = [];
	SelectedVisitorPass: any;
	LoadingPasses: boolean = false;

	VisitorSignature: string = "";
	PassImage_PNG: string = "";

	lstScans: any = [];
	LoadingScans: boolean = false;

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadPasses() {
		this.ClearData();

		if (this.SelectedVisitor == undefined || this.SelectedVisitor.PersonID == undefined) {
			return;
		}

		this.LoadingPasses = true;

		var result = this.visitorService.VisitorHistorySelectList(this.SelectedVisitor.PersonID);
		result.subscribe(
			(response) => {
				this.lstVisitorPass = response;

				this.LoadingPasses = false;
			},
			(error) => {
				this.LoadingPasses = false;
			}
		);
	}

	loadScans() {
		this.lstScans = [];

		if (this.SelectedVisitorPass == undefined) {
			return;
		}

		this.LoadingScans = true;

		var result = this.visitorService.PassLoadExtendedInfo(this.SelectedVisitorPass.VisitorPassID);
		result.subscribe(
			(response: any) => {
				this.VisitorSignature = response.VisitorSignature == undefined ? "" : response.VisitorSignature;
				this.PassImage_PNG = response.PassImage_PNG == undefined ? "" : response.PassImage_PNG;
				this.lstScans = response.lstScans == undefined ? [] : response.lstScans;

				this.LoadingScans = false;
			},
			(error) => {
				this.LoadingScans = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onVisitorPassSelected(val) {
		this.SelectedVisitorPass = val;
		this.PassImage_PNG = "";
		this.VisitorSignature = "";

		this.loadScans();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	ClearData() {
		this.lstVisitorPass = [];
		this.SelectedVisitorPass = null;
		this.lstScans = [];
		this.PassImage_PNG = "";
		this.VisitorSignature = "";
	}

	////////////////////////////////////////////
}
